import { render, staticRenderFns } from "./InvoiceA5Delivery.vue?vue&type=template&id=f0975d68&scoped=true"
import script from "./InvoiceA5Delivery.vue?vue&type=script&lang=js"
export * from "./InvoiceA5Delivery.vue?vue&type=script&lang=js"
import style0 from "./InvoiceA5Delivery.vue?vue&type=style&index=0&id=f0975d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0975d68",
  null
  
)

export default component.exports